import type { FieldDef } from '../../types'
import { CreateEntityPage } from '../CreateEntityPage/CreateEntityPage'
import { createTenant } from '../../services/api/createTenant'
import { useTenantGroups } from '../../hooks/useTenantGroups'

export function CreateTenantPage() {
  const { tenantGroups, isLoading } = useTenantGroups()

  const tenantGroupOptions = tenantGroups
    .map((tg) => ({ value: tg.id, label: `${tg.code} (ID: ${tg.id})` }))
    .sort((a, b) => a.label.localeCompare(b.label))

  const fields: FieldDef[] = [
    { name: 'code', label: 'Code', type: 'text' },
    { name: 'name', label: 'Name', type: 'text' },
    {
      name: 'tenantGroupId',
      label: 'Tenant Group',
      type: 'select',
      searchable: true,
      options: tenantGroupOptions,
      valueType: 'number',
    },
  ]

  return (
    <CreateEntityPage
      title="Create Tenant"
      backTo="/tenants"
      loadingLabel="tenant"
      fields={fields}
      createFn={createTenant}
      isLoading={isLoading}
    />
  )
}
